function updateFixedElementHeight() {
    var parentHeight = $('.promo--home').height() + 'px';
    $('.promo--home').css('--parent-height', parentHeight);

    var infoBannerHeight = $('.info-banner').outerHeight(true) + 'px';
    $('.promo--home').css('--info-banner-height', infoBannerHeight);
}

$(document).ready(function () {
    updateFixedElementHeight();
});

$(window).on('resize', function () {
    updateFixedElementHeight();
});
